<template>
  <section>
    <h3 class="primary--text">
      <template v-if="eventDateObj.params !== null && activityValue">

        <template v-if="!eventDateObj.activity.includes('document')">
          <router-link
            class="no-link-style" style="font-weight:500" :to="{
            name: activityValue.pathName,
            params: getLinkParams(activityValues, eventDateObj)
          }">
            {{ eventDateObj.params[activityValue.title] }}
          </router-link>
        </template>
        <template v-else>
          <a @click="viewFile(eventDateObj)" class="no-link-style" style="font-weight:500" >
            {{ eventDateObj.params[activityValue.title] }}
          </a>
        </template>
      </template>
      {{additionalMessage}}
      {{ text }}
      <span style="font-weight:500"><router-link class="no-link-style" style="font-weight:500" :to="{ name: 'Case', params: { case_id: eventDateObj.caseId} }">{{ eventDateObj.title }}</router-link></span>
    </h3>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Helpers from '@/helpers.js'
import { lookupByEventType, normaliseEventType } from "@/stores/timeline/eventTypes"

export default {
  name: "DoublePostTitle",
  data: () => ({
    activityValues: {
      "document.uploaded": {
        title: "filename",
        pathName: 'Case',
        isDocument: true,
        viewing: false,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "document.viewed": {
        title: "filename",
        pathName: 'Case',
        isDocument: true,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "document.updated": {
        title: "filename",
        pathName: 'Case',
        isDocument: true,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "document.deleted": {
        title: "filename",
        pathName: 'Case',
        isDocument: true,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "document.downloaded": {
        title: "filename",
        pathName: 'Case',
        isDocument: true,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "document.duplicated": {
        title: "filename",
        pathName: 'Case',
        isDocument: true,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "conversation.created": {
        title: "author_display_name",
        pathName: 'UserEdit',
        isDocument: false,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'author_id',
            locatedInParams: true
          }
        ]
      },
      "conversation.replied": {
        title: "author_display_name",
        pathName: 'UserEdit',
        isDocument: false,
        params: [
          {
            pathParam: 'id',
            pathParamValue: 'author_id',
            locatedInParams: true
          }
        ]
      },
      "task.created": {
        title: "name",
        pathName: 'Case',
        isDocument: false,
        params: [
          {
            pathParam: 'case_id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "tasklist.created": {
        title: "name",
        pathName: 'Case',
        isDocument: false,
        params: [
          {
            pathParam: 'case_id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "task.executed": {
        title: "description",
        pathName: 'Case',
        isDocument: false,
        params: [
          {
            pathParam: 'case_id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      },
      "task.updated": {
        title: "description",
        pathName: 'Case',
        isDocument: false,
        params: [
          {
            pathParam: 'case_id',
            pathParamValue: 'id',
            locatedInParams: false
          }
        ]
      }
    }
  }),
  props: ["eventDateObj", "text", "accountId"],
  components: {
    ...mapState({
      activity: state => state.timeline.event_types
    })
  },
  methods: {
    getLinkParams: function(activityValues, eventDateObj) {
      return Helpers.getLinkParams(activityValues, eventDateObj)
    },
    async viewFile(event) {
      if (!this.viewing) {
        this.viewing = true
        const url = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${event.params.url}` : event.params.url
        const auth = 'Bearer ' + window.localStorage.session

        const anchor = document.createElement("a")
        document.body.appendChild(anchor)
        const headers = new Headers()
        headers.append("Authorization", auth)

        const response = await fetch(url, { headers })
        const blobby = await response.blob()
        const objectUrl = window.URL.createObjectURL(blobby)
        anchor.href = objectUrl
        anchor.target = "blank"
        anchor.click()
        this.viewing = false
      }
    }
  },
  computed: {
    ...mapGetters({
      getApiEndPoint: 'getApiEndPoint'
    }),
    activityValue() {
      return lookupByEventType(this.activityValues, this.eventDateObj && this.eventDateObj.activity)
    },
    additionalMessage: function() {
      if (this.eventDateObj && normaliseEventType(this.eventDateObj.activity) === "task.executed") {
        return this.eventDateObj.message
      }
      return ""
    }
  }
}
</script>
